export const routes = [
  {
    path: '/analytics-cross-cutting-task',
    name: 'analytics-cross-cutting-task',
    component: () => import('@/modules/analyticsForCrossCuttingTasks/pages/PageAnalyticsForCrossCuttingTasks.vue'),
  },
  {
    path: '/analytics-cross-cutting-task-detail/:id',
    name: 'analytics-cross-cutting-task-detail',
    component: () =>
      import('@/modules/analyticsForCrossCuttingTasks/pages/PageAnalyticsForCrossCuttingTasksDetail.vue'),
  },
];
